// extracted by mini-css-extract-plugin
export var loadingSpinner = "_24-0";